export async function updateTeamSettings({ autoJoin, teamSize, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateTeamSettings`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    },
    body: JSON.stringify({ autoJoin, teamSize }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to update team settings");
  }
  return data;
}
